import styled from "@emotion/styled";

import { Info } from "@livechat/design-system-icons";
import { Icon, SpacingToken, Tooltip } from "@livechat/design-system-react-components";

import { IRecurlyCoupon } from "store/entities/recurly";
import { RecurlyCouponDuration } from "store/entities/recurly/interfaces";
import { withVar } from "themes/helpers";

export interface IProps {
  coupon: IRecurlyCoupon | null;
}

const getTooltipContent = (coupon: IRecurlyCoupon): string => {
  if (coupon.duration === RecurlyCouponDuration.SingleUse) {
    return "Discount will be applied to your first payment.";
  }

  if (coupon.duration === RecurlyCouponDuration.Forever) {
    return "Discount will be applied to your all payments.";
  }

  return "The discount will be calculated according to your subscription and discount policy.";
};

export const CouponTooltip = ({ coupon }: IProps): JSX.Element => (
  <Tooltip
    isVisible={coupon ? undefined : false}
    arrowOffsetX={1}
    placement="top"
    kind="invert"
    triggerRenderer={<StyledIcon source={Info} size="small" />}
  >
    {getTooltipContent(coupon as IRecurlyCoupon)}
  </Tooltip>
);

const StyledIcon = styled(Icon)`
  padding-left: ${withVar(SpacingToken.Spacing05)};
`;
